










































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {ListGithubRepositorySchema} from '@/schema/resource/GithubRepository/ListGithubRepositorySchema'

@Component({
  components: {},
})
export default class ListGithubRepositoryView extends Mixins(MixinRouteMatch) {
  schema = new ListGithubRepositorySchema()
  collection = new GithubRepositoryCollection()

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }

    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  async removeItem(item: GithubRepository) {
    await this.$dialog.remove(item)
    await item.removeGithubRepository()
    await this.collection.queryAsPage()
  }

  goToPersistView(item: GithubRepository) {
    this.$nav.pushByName('editGithubRepository', item.$id)
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }
}
